import React from 'react';
import { Crown, Shield, Users, Wrench, Megaphone } from 'lucide-react';
import { cn } from '../lib/utils';

const RoleBadge = ({ role, showIcon = true, size = 'default' }) => {
  const roleConfig = {
    owner: {
      label: 'Owner',
      icon: Crown,
      bgColor: 'bg-yellow-100',
      textColor: 'text-yellow-800',
      borderColor: 'border-yellow-200',
    },
    admin: {
      label: 'Admin',
      icon: Shield,
      bgColor: 'bg-purple-100',
      textColor: 'text-purple-700',
      borderColor: 'border-purple-200',
    },
    sales: {
      label: 'Sales',
      icon: Users,
      bgColor: 'bg-blue-100',
      textColor: 'text-blue-700',
      borderColor: 'border-blue-200',
    },
    technician: {
      label: 'Technician',
      icon: Wrench,
      bgColor: 'bg-green-100',
      textColor: 'text-green-700',
      borderColor: 'border-green-200',
    },
    marketing: {
      label: 'Marketing',
      icon: Megaphone,
      bgColor: 'bg-orange-100',
      textColor: 'text-orange-700',
      borderColor: 'border-orange-200',
    },
  };

  const config = roleConfig[role] || roleConfig.sales;
  const Icon = config.icon;

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    default: 'px-2.5 py-1 text-sm',
    lg: 'px-3 py-1.5 text-base',
  };

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-md font-medium border',
        config.bgColor,
        config.textColor,
        config.borderColor,
        sizeClasses[size]
      )}
    >
      {showIcon && <Icon className="h-3.5 w-3.5" />}
      {config.label}
    </span>
  );
};

export default RoleBadge;
